"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CATEGORY = void 0;
var CATEGORY = {
  consumption: 'consumption',
  energy: 'energy',
  food: 'food',
  foodWaste: 'foodWaste',
  household: 'household',
  plastic: 'plastic',
  public: 'public',
  sustainableFood: 'sustainableFood',
  transport: 'transport',
  tutorial: 'tutorial',
  workTransport: 'workTransport',
  nature: 'nature',
  treeGroup: 'treeGroup'
};
exports.CATEGORY = CATEGORY;
//# sourceMappingURL=category.enum.js.map